"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSocketEventListeners = void 0;
const useOnFeedActivityUpdate_1 = require("./useOnFeedActivityUpdate");
const useGetSocketEventListeners = (entities, isInternalActivitiesEnabled) => {
    const onFeedActivityUpdate = (0, useOnFeedActivityUpdate_1.useOnFeedActivityUpdate)(entities);
    const internalDomainEventListeners = isInternalActivitiesEnabled
        ? [
            {
                eventType: 'ws-internal-feed-activity-created',
                callback: (response) => onFeedActivityUpdate(response.payload),
            },
        ]
        : [];
    const publicDomainEventListeners = {
        eventType: 'ws-public-feed-activity-created',
        callback: (response) => onFeedActivityUpdate(response.payload),
    };
    const eventListeners = [publicDomainEventListeners, ...internalDomainEventListeners];
    return eventListeners;
};
exports.useGetSocketEventListeners = useGetSocketEventListeners;
//# sourceMappingURL=useGetSocketEventListeners.js.map